import React from 'react';
import './PanelPage.css';
import UsuarioComponent from '../../components/Usuario/Usuario';
import MenuComponent from '../../components/Menu/Menu';

const PanelPage = () => {

  return (
    <div className= "contenedor-izquierdo-prefectos">
      <div id= "panelUsuario-prefectos">
        <UsuarioComponent />
      </div>
      <div id= "panelMenu-prefectos">
        <MenuComponent />
      </div>
    </div>
  );

};

export default PanelPage;
